// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PasswordInput_wrapper__DGbbt","input":"PasswordInput_input__SRgwV","toggle":"PasswordInput_toggle__UhmpP"};